import React from 'react';

const useContainerClassname = (className?: string): string => {
  return React.useMemo<string>(() => {
    return [
      'p-8 text-black w-96 rounded-lg bg-gray-50 m-auto max-h-[calc(100vh-100px)] overflow-y-auto flex flex-col'
    ]
      .addNotEmpty(className)
      .toClassNames();
  }, [className]);
};

export default useContainerClassname;
